// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"21dc108c","453":"7e169f0e","455":"40d09c97"}[chunkId] + ".chunk.js";
};